import axios from 'axios';

const getDashboard = async () => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/dashboard`,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data?.dashboard;
};

export default getDashboard;
